import { useTranslation } from 'next-i18next';
import { AgendaComponentInterface, AgendaEntry, AgendaGroupBy } from '../../../../../interfaces/pagebuilder';
import { CustomTranslationForm } from '../../../../common/CustomTranslationForm';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';
import EntrySettingsForm from './EntrySettingsForm';

interface AgendaSettingsTableInterface {
  component: AgendaComponentInterface;
  onChange: (c: AgendaComponentInterface) => void;
}

const AgendaSettingsTable = ({ component, onChange }: AgendaSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  function onChangeEntries(entryList: AgendaEntry[]) {
    onChange({ ...component, entryList });
  }
  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          hasDefaultPadding: false,
          content: (
            <CustomTranslationForm
              defaultValue={component?.titleTranslations || []}
              useInternalForm={true}
              onChange={(data) => {
                onChange({ ...component, titleTranslations: data });
              }}
            />
          ),
        },
        {
          label: t('pagebuilder:group-by'),
          type: 'select',
          path: 'groupBy',
          selectItems: Object.keys(AgendaGroupBy).map((groupBy) => ({ key: groupBy, name: t(`pagebuilder:${groupBy}`), value: groupBy })),
          selectProps: {
            displayEmpty: true,
            labelId: 'group-by-select',
          },
          defaultValue: component.groupBy,
        },
        {
          label: t('pagebuilder:allow-entries-favoriting'),
          type: 'boolean',
          path: 'allowEntriesFavoriting',
          selectItems: Object.keys(AgendaGroupBy).map((groupBy) => ({ key: groupBy, name: t(`pagebuilder:${groupBy}`), value: groupBy })),
        },
        {
          label: t('pagebuilder:allow-calendar-export'),
          type: 'boolean',
          path: 'allowCalendarExport',
          selectItems: Object.keys(AgendaGroupBy).map((groupBy) => ({ key: groupBy, name: t(`pagebuilder:${groupBy}`), value: groupBy })),
        },
        {
          content: <EntrySettingsForm component={component} onChange={onChangeEntries} />,
        },
      ],
    },
  ];
  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />;
};
export default AgendaSettingsTable;
